import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { INewsItem } from "../models/INews";
import { IPage } from "../models/IPage";

export class NewsApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getNews(pageSelect: IPage, success: (data: IPaginatedResponse<INewsItem[]>) => void, error?: (message: string) => void) {
        this.getPaginated<INewsItem[]>(`${Utils.LIB_API_BASE_URL}/news?pageNumber=${pageSelect.pageNumber}&pageSize=${pageSelect.pageSize}`, success, error);
    }

    downloadNewsAttachment(newsFileId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/news/file/${newsFileId}`, fileName ?? "", undefined, error);
    }
}
